var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgTotalQualifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13",
    stroke: "#3BB182",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33008 14.4917L9.71008 11.4017C10.0501 10.9617 10.6801 10.8817 11.1201 11.2217L12.9501 12.6617C13.3901 13.0017 14.0201 12.9217 14.3601 12.4917L16.6701 9.51172",
    stroke: "#3BB182",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4802 15.8214L19.7602 16.3914C19.9002 16.6714 20.2502 16.9314 20.5602 16.9914L20.9402 17.0514C22.0802 17.2414 22.3502 18.0814 21.5302 18.9114L21.1802 19.2614C20.9502 19.5014 20.8202 19.9614 20.8902 20.2814L20.9402 20.4914C21.2502 21.8714 20.5202 22.4014 19.3202 21.6814L19.0602 21.5314C18.7502 21.3514 18.2502 21.3514 17.9402 21.5314L17.6802 21.6814C16.4702 22.4114 15.7402 21.8714 16.0602 20.4914L16.1102 20.2814C16.1802 19.9614 16.0502 19.5014 15.8202 19.2614L15.4702 18.9114C14.6502 18.0814 14.9202 17.2414 16.0602 17.0514L16.4402 16.9914C16.7402 16.9414 17.1002 16.6714 17.2402 16.3914L17.5202 15.8214C18.0602 14.7314 18.9402 14.7314 19.4802 15.8214Z",
    stroke: "#3BB182",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalQualifications);
export default __webpack_public_path__ + "static/media/total-qualifications.1fc13961d05da3afbe74182ea6c2f149.svg";
export { ForwardRef as ReactComponent };